module.exports = __webpack_public_path__ + "img/zk-icon-finance-details.cec5589b.svg";